import { Component, ViewChild, Injectable, ErrorHandler, Injector } from '@angular/core';
import { Nav, Platform, IonicErrorHandler } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Http } from "@angular/http";

import { HomePage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';
import { SalirPage } from '../pages/salir/salir';

// Servicios de base de datos
import { pouchdb2 } from '../services/pouchdb/pouchdb.service'

import { Network } from '@ionic-native/network';
import { Subscription } from 'rxjs/Subscription';
import { ToastController } from 'ionic-angular/components/toast/toast-controller';

// Servicios para el tracking de errores
import { Pro } from '@ionic/pro';
import { iConfiguracion } from '../models/basePage';
import { RegistroLogsPage } from '../pages/registro-logs/registro-logs';
import { APIOnLine } from '../services/api/api.services';
import { AjustesPage } from '../pages/ajustes/ajustes';

var IonicPro;

@Injectable()
export class MyErrorHandler implements ErrorHandler {
  ionicErrorHandler: IonicErrorHandler;

  constructor(injector: Injector) {
    try {
      this.ionicErrorHandler = injector.get(IonicErrorHandler);
    } catch (e) {
    }
  }

  handleError(err: any): void {
    if (IonicPro != null) {
      IonicPro.monitoring.handleNewError(err);
      this.ionicErrorHandler && this.ionicErrorHandler.handleError(err);
    }
  }
}

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = LoginPage;

  pages: Array<{ title: string, component: any, icon: string }>;

  public connectSubscription: Subscription;
  public disconnectSubscription: Subscription;

  public pruebas: boolean = false;
  public beta: boolean = false;

  constructor(
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    private DBService2: pouchdb2.DBService2,
    private toastCtrl: ToastController,
    private network: Network,
    public http: Http,
    public Persistentes: APIOnLine.Persistentes
  ) {
    console.log("Llego al constructor de app.components.ts");

    // Obtención del archivo de configuración (datos.json)
    this.http.get("./assets/data/datos.json").toPromise()
      .then((resultado: any) => {
        let configuraciones: iConfiguracion = <iConfiguracion>resultado.json();

        // Guardado de la configuración en el servicio Persistente
        this.Persistentes.SetConfiguracion(configuraciones);

        // En Pruebas
        this.pruebas = configuraciones.pruebas;
        console.log("Versión en pruebas: " + this.pruebas);

        // Versión beta
        this.beta = configuraciones.beta;
        console.log("Versión Beta: " + this.beta);

        // Versión online
        console.log("Versión ONLINE: " + (configuraciones.online ? "Si" : "No"));

        // Activada la opción de Lesionados
        console.log("Lesionados: ", configuraciones.lesionados);

        if (!configuraciones.online) {
          this.initializeApp(configuraciones);
        }
      })
      .catch(error => this.Mensaje("No se ha podido obtener el archivo con los datos de la configuración de la APP.", "", 0));

    // used for an example of ngFor and navigation
    this.pages = [
      { title: 'Inicio', component: HomePage, icon: "home" },
      {
        title: 'Ajustes',
        component: AjustesPage,
        icon: 'settings'
      },
      {
        title: 'Salir', component: SalirPage, icon: "exit"
      }
    ];
  }

  private initializeApp(configuraciones: iConfiguracion) {
    //this.splashScreen.show();

    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();

      setTimeout(() => {
        this.splashScreen.hide();
        console.log('Se oculta la SplashScreen');
      }, 100);

      this.DBService2.initDB();

      this.ConfiguracionIONIC(configuraciones);

      // Comprobar la conexión a Internet
      this.connectSubscription = this.network.onConnect()
        .subscribe(() => {
          setTimeout(() => {
            let cadena: string = this.network.type != null ? this.network.type.toString() : 'No hay datos del tipo de conexión';
            this.Mensaje('Tiene conexión a la Red: ' + cadena, '', 6000);
          }, 100);
        });

      this.disconnectSubscription = this.network.onDisconnect()
        .subscribe(() => {
          setTimeout(() => {
            let cadena: string = this.network.type != null ? this.network.type.toString() : 'No hay datos del tipo de conexión';
            this.Mensaje('Ha perdido la conexión a la Red: ' + cadena, '', 6000);
          }, 100);
        });
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
  }

  private ConfiguracionIONIC(configuraciones: iConfiguracion): void {
    IonicPro = Pro.init(configuraciones.ionic.id, {
      appVersion: configuraciones.version
    });

    Pro.getApp().monitoring.log('Aplicación inicializada.', {
      level: 'info'
    });
  }

  public openRegistroLogs(): void {
    this.nav.setRoot(RegistroLogsPage);
  }

  private Mensaje(texto: string, clase: string, duracion: number): void {
    let toast = this.toastCtrl.create({
      message: texto,
      position: 'top',
      cssClass: clase,
      duration: duracion
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts